import React, { useState, useEffect, useRef } from "react";
import { InputWrap, LabelWrapper, DropArea, DropAreaLabel, Error } from "./styled";
import { useThemeUI } from "theme-ui";
import { getPresignedUrl } from "api/Media";

const FileInput = ({ 
  label, 
  directory,
  description, 
  required,
  disabled, 
  placeholder,  
  multiple,
  refreshValue,
  presign,
  $customStyles, 
  $errors, 
  $responseErrors, 
  onChange 
}:{
  label?: string | React.ReactNode;  
  directory?: string;
  description?: string; 
  required?: boolean;
  disabled?: boolean;
  multiple?: boolean;
  placeholder?: string; 
  refreshValue?: boolean;
  /** Override how the signed upload URL is obtained (e.g. the driver page, which has no login). */
  presign?: (file: File) => Promise<any>;
  $customStyles?: any;
  $responseErrors?: any;
  $errors?: any;
  onChange?: (a?: any) => void;
}) => {



  const themeContext = useThemeUI();
  const { theme } = themeContext;
  
  const fileInputRef = useRef<any>(null);

  const [files, setFiles] = useState<any[]>([]);
  const [values, setValues] = useState<any[]>([]);
  const [borderError, setBorderError] = useState<any>(false);

  const handleDragOver = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setFiles(multiple ? e.dataTransfer.files : [e.dataTransfer.files[0]]);
  };

  const handleFileChange = (e: any) => {
    setFiles(multiple ? e.target.files : [e.target.files[0]]);
  };

  const handleUpload = async () => {    
    if(disabled || files.length === 0) return true;         

    const tempFiles: any[] = [];    
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const signedurl = presign
        ? await presign(file)
        : await getPresignedUrl({ data : { directory : directory || "", name : file.name, type : file.type, size : file.size }});            
      if(signedurl.success && typeof onChange === "function"){      
        tempFiles.push({
          file : file,
          url : signedurl.url, 
          title: signedurl.name, 
          location : signedurl.location
        })
      }
    } 
    setValues(tempFiles);  
  }

  useEffect(() => {
    if(typeof onChange === "function"){
      onChange(values);
    }
  },[values]);

  useEffect(() => {
    handleUpload();
  },[files]);

  useEffect(() => {
    if(refreshValue){
      setFiles([]);
    }
  },[refreshValue])

  useEffect(() => {
    if($responseErrors || $errors){
      setBorderError(true);
    }else{
      setBorderError(false);
    }
  },[$responseErrors, $errors]);

  return (
    <InputWrap theme={theme} sx={$customStyles} $errors={borderError}>
      {label && 
        <LabelWrapper theme={theme}>
          <label>{label}</label>
          {required ? <span>*</span>  : ''}         
        </LabelWrapper>
      }
      <DropArea
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        onClick={() => fileInputRef.current.click()}
      >
        <DropAreaLabel>{placeholder || "Drag and drop or select files here"}</DropAreaLabel>
        {values.length > 0 && values.map((file: any, index: number) => <div key={index} style={{fontWeight:"600", fontSize:"14px", marginTop:"10px"}}>{file.title}</div>)}
      </DropArea>
      <input type="file" ref={fileInputRef} onChange={handleFileChange} multiple={multiple} hidden />
      {description && <p><small>{description}</small></p>}       
      {$errors && <Error theme={theme}>{$errors}</Error>}
    </InputWrap>    
  );
};

export default FileInput;
